<template>
	<div>
		<img :src="require(`../../../../assets/image/${imageName}`)" alt="">
	</div>
</template>

<script>
	export default {
		name: "SlideComponent",
		props: ['imageName'],
	}
</script>

<style scoped>
	img {
		min-width: 100%;
		height: 100%;
		filter: brightness(55%);
		z-index: -1;
	}
</style>